import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import { findCounter } from "./findCounter";

// Asigna instalaciones a la plantilla de archivos
export const assignLocations = createAsyncThunk(
  "userProfileLocation/assignLocations",
  async (arg, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState() as RootState;
      const selectedLocations = state.formSubmittedSlice.selectedLocations;
      const template = state.templateDetail.template;
      let locationsToSave = [...selectedLocations];
      const assignedLocations = state.formSubmittedSlice.assignedLocations;
      const idsToDelete: string[] = [];

      // Se comprueba si los locations ya asignados se encuentran dentro de los seleccionados.
      // Si los encuentra los elimina del listado para crear registros (locationsToSave).
      // Si no los encuentra guarda el id en listado para eliminar registros (IdsToDelete).
      assignedLocations.forEach(async (element) => {
        if (locationsToSave.find(({ id }) => Number(id) === element.location.id)) {
          locationsToSave = locationsToSave.filter(({ id }) => Number(id) !== element.location.id);
        } else {
          idsToDelete.push(element.id.toString());
        }
      });
      // Genera listado de ids de locations para guardar registros
      const idsLocationsToSave = locationsToSave.map((element) => element.id);
      const url = new URL(`${api.baseURL}formsubmitted/delete-list`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");
      // Eliminar registros
      if (idsToDelete.length > 0) {
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            toDelete: idsToDelete.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }

      // Crea registros
      if (idsLocationsToSave.length > 0) {
        const url = new URL(`${api.baseURL}formsubmitted/create-list`);
        let response = await fetch(url.toJSON(), {
          body: JSON.stringify({
            form: template.id,
            toAddLocationIds: idsLocationsToSave.toString(),
          }),
          method: "POST",
          headers: headers,
        });
        if (!response.ok) {
          throw response.statusText;
        }
      }
      dispatch(findCounter({ form: template.id }));
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
